import { AdjustedProductType, ProductType } from "../interfaces/DTO/mislaka_xml_models";
import { ManualInvestmentPortfolioAdjustedType, ManualProductType } from "../interfaces/DTO/manualMimshakData";
import { formatAdjustedProductType, formatProductType } from "./enumFormatter";
import { formatManualAdjustedType, formatManualProductType } from "./manualProductTypeFormatter";

/** an investment portfolio's sub-type (its adjusted_product_type - 6001 self-managed / 6002 managed) */
export const isInvestmentPortfolioSubType = (productType: number) =>
  Object.values(ManualInvestmentPortfolioAdjustedType).includes(productType as ManualInvestmentPortfolioAdjustedType);

/**
 * פורמטר אוניברסלי לסוג מוצר (product_type)
 * מנסה את כל ה-enums הידועים עד שמוצא התאמה
 * אם לא מוצא - מחזיר את הערך המקורי
 */
export const formatProductTypeUniversal = (productType: number): string => {
  if (productType === undefined || productType === null) return "";

  // ניסיון 1: AdjustedProductType (כולל ביטוח מנהלים 111/112)
  if (Object.values(AdjustedProductType).includes(productType as AdjustedProductType)) {
    return formatAdjustedProductType(productType as AdjustedProductType);
  }

  // ניסיון 2: ProductType רגיל (מהמסלקה)
  if (Object.values(ProductType).includes(productType as ProductType)) {
    return formatProductType(productType as ProductType);
  }

  // ניסיון 3: ManualProductType (נכסים ידניים)
  if (Object.values(ManualProductType).includes(productType as ManualProductType)) {
    return formatManualProductType(productType as ManualProductType);
  }

  // ניסיון 4: תת-סוג של תיק השקעות - "תיק השקעות מנוהל" / "תיק השקעות בניהול עצמי"
  if (isInvestmentPortfolioSubType(productType)) {
    return `${formatManualProductType(ManualProductType.INVESTMENT_PORTFOLIO)} ${formatManualAdjustedType(productType)}`;
  }

  // אם לא מצאנו התאמה - מחזיר את המספר המקורי
  return `${productType}`;
};
